import { formatNumber } from 'utils/numberFormat';
import { HTMLAttributes, memo } from 'react';
import { useTranslate } from '@tolgee/react';
import { Detail, priceRender } from './TradeDetailPaymentLazada';

export interface TradeIncomeAmountProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.Vo;
  defaultFold?: boolean;
}

/** shopee 买家实付金额 */
function TradeDetailIncomeAliExpress(props: TradeIncomeAmountProps) {
  const { trade } = props;

  const { unit, tradeIncome } = trade;

  const { t } = useTranslate();

  return (
    <Detail>
      {priceRender(tradeIncome?.itemPrice, (val) => {
        return (
          <li>
            <dt>{t('domain.order.income.field.productAmount')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(tradeIncome?.shippingFee, (val) => {
        return (
          <li>
            <dt>{t('domain.order.income.field.shippingSubtotal')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}

      {priceRender(tradeIncome?.vat, (val) => {
        return (
          <li>
            <dt>{t('domain.order.income.field.valueAddedTax')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}

      {priceRender(tradeIncome?.orderAmount, (val) => {
        return (
          <li>
            <dt>{t('domain.order.income.field.orderAmount')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}

      {priceRender(tradeIncome?.escrowAmount, (val) => {
        return (
          <li>
            <dt>{t('domain.order.income.field.orderIncome')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
    </Detail>
  );
}

export default memo(TradeDetailIncomeAliExpress);
